import { render } from "./Cover.vue?vue&type=template&id=489add0a"
import script from "./Cover.vue?vue&type=script&lang=js"
export * from "./Cover.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__